import React,{Component} from 'react';
import {Tab,Tabs,AppBar,TabPanel} from '@material-ui/core';
import Usuarios from '../Usuarios/ListarUsuarios';
import Comprobantes from '../Comprobantes/SubirComprobantes';
import Listado from '../Retenciones/ListarRetencionesAdmi';

export default class VistaAdmin extends Component{
    constructor(props){
        super(props);
        this.state={
            actual:0,
            usuario:props.usuario,
        }
    }
    componentWillReceiveProps(props){
        this.setState({
            usuario:props.usuario
        })
    }


    render(){
        return(<div style={{margin:'10px'}}>
                <AppBar position='static'></AppBar>
                <Tabs value={this.state.actual} onChange={(ev,val)=>this.setState({actual:val})}>
                    <Tab label='Gestion de Usuarios' />
                    <Tab label='Ingreso de Comprobantes'/>
                    <Tab label='Listado de Retenciones'/>
                </Tabs>
                <div hidden={this.state.actual !== 0} index={0} style={{margin:'5px'}}>
                    <Usuarios usuario={this.state.usuario} ></Usuarios>
                </div>
                <div hidden={this.state.actual !== 1} index={1} style={{margin:'5px'}}>
                    <Comprobantes></Comprobantes>
                </div>
                <div hidden={this.state.actual !== 2} index={2} style={{margin:'5px'}}>
                    <Listado></Listado>
                </div>
            </div>)
    }
}